export default "__VITE_ASSET__67bdadb9__"